import { useQueryParamHelper } from '@shared/core/queryString';

export const RETURN_URL_PARAM_KEY = 'prev';

export function useReturnUrlParam() {
  const paramHelper = useQueryParamHelper();
  const value = paramHelper.getValueString(RETURN_URL_PARAM_KEY);
  return value;
}
